import { TableColumn } from '@/classes'

const Columns = [
  new TableColumn('Batch No.', 'batchNo', true, 'desc', 'left'),
  // new TableColumn('Insurer', 'insurer', true, 'desc', 'left'),
  new TableColumn('Status', 'batchStatus', true, 'desc', 'left'),
  new TableColumn('Count', 'count', true, 'desc', 'right'),
  new TableColumn('Date', 'batchDate', true, 'desc', 'left'),
  new TableColumn('Agreed ARC', 'agreedArc', true, 'desc', 'right'),
  new TableColumn('Avg Labour (Hrs)', 'averageLabourUnit', true, 'desc', 'right'),
  new TableColumn('Avg Labour ($)', 'averageLabourValue', true, 'desc', 'right'),
  new TableColumn('ALR', 'averageLabourRate', true, 'desc', 'right'),
  new TableColumn('ARC', 'averageRepairCost', true, 'desc', 'right'),
  new TableColumn('Adjustment', 'adjustment', false, 'desc', 'right'),
  new TableColumn('', 'action', false, 'desc', 'centered')
  // new TableColumn('', 'action', false, 'desc', 'centered')
]

const BatchQuoteColumns = [
  new TableColumn('Quote No', 'quoteNo', true, 'desc', 'left'),
  new TableColumn('Claim No', 'claimNo', true, 'desc', 'left'),
  new TableColumn('Rego', 'rego', true, 'desc', 'left'),
  new TableColumn('Name', 'customerName', true, 'desc', 'left'),
  new TableColumn('Excess', 'excess', true, 'desc', 'right'),
  new TableColumn('Labour (Hrs)', 'labourUnit', true, 'desc', 'right'),
  new TableColumn('Rate', 'rate', true, 'desc', 'right'),
  new TableColumn('Labour ($)', 'labourValue', true, 'desc', 'right'),
  new TableColumn('Part', 'partTotal', true, 'desc', 'right'),
  new TableColumn('Sublet', 'subletTotal', true, 'desc', 'right'),
  new TableColumn('Misc', 'miscTotal', true, 'desc', 'right'),
  new TableColumn('Total', 'totalExGst', true, 'desc', 'right'),
  new TableColumn('Inv\'d', 'invoiced', true, 'desc', 'centered'),
  // new TableColumn('Inv No', 'invoiceNo', true, 'desc', 'left'),
  new TableColumn('Status', 'quoteStatusId', false, 'desc', 'left'),
  new TableColumn('QDE Status', 'qdeStatus', false, 'desc', 'left'),
  new TableColumn('Diff', 'delta', true, 'desc', 'right'),
  new TableColumn('', 'action', false, 'desc', 'centered')
]

const AvailableQuoteColumns = [
  new TableColumn('Quote No.', 'quoteNo', true, 'desc', 'left'),
  new TableColumn('Claim No', 'claimNo', true, 'desc', 'left'),
  new TableColumn('Rego', 'rego', true, 'desc', 'left'),
  new TableColumn('Name', 'customerName', true, 'desc', 'left'),
  new TableColumn('Excess', 'excess', true, 'desc', 'right'),
  new TableColumn('Labour (Hrs)', 'labourUnit', true, 'desc', 'right'),
  new TableColumn('Rate', 'rate', true, 'desc', 'right'),
  new TableColumn('Labour ($)', 'labourValue', true, 'desc', 'right'),
  new TableColumn('Part', 'partTotal', true, 'desc', 'right'),
  new TableColumn('Sublet', 'subletTotal', true, 'desc', 'right'),
  new TableColumn('Misc', 'miscTotal', true, 'desc', 'right'),
  new TableColumn('Total', 'totalExGst', true, 'desc', 'right'),
  // new TableColumn('Diff', 'delta', true, 'desc', 'right'),
  new TableColumn('', 'action', false, 'desc', 'centered')
]

const BatchingQuoteColumns = [
  new TableColumn('Quote No', 'quoteNoRef', true, 'asc', 'left'),
  new TableColumn('Status', 'quoteStatus', true, 'desc', 'left'),
  new TableColumn('Job Stage', 'jobStage', true, 'desc', 'left'),
  new TableColumn('Quote Status', 'qdeStatus', false, 'desc', 'left'),
  // new TableColumn('Severity', 'hasSeverity', true, 'desc', 'centered'),
  // new TableColumn('Start Date', 'jobStart', true, 'desc', 'centered'),
  new TableColumn('End Date', 'jobEnd', true, 'desc', 'centered'),
  new TableColumn('Days Elapsed', 'daysElapsed', true, 'desc', 'centered'),
  new TableColumn('Claim No', 'claimNo', true, 'desc', 'left'),
  new TableColumn('Rego', 'rego', true, 'desc', 'centered'),
  new TableColumn('Name', 'fullName', true, 'desc', 'left'),
  new TableColumn('Insurer', 'insurer', true, 'desc', 'left'),
  new TableColumn('Excess', 'excessInvoice', true, 'desc', 'right'),
  new TableColumn('Labour (Hrs)', 'labourHour', true, 'desc', 'right'),
  new TableColumn('Rate', 'rate', true, 'desc', 'right'),
  new TableColumn('Labour ($)', 'labourTotal', true, 'desc', 'right'),
  new TableColumn('Part', 'partTotal', true, 'desc', 'right'),
  new TableColumn('Sublet', 'subletTotal', true, 'desc', 'right'),
  new TableColumn('Misc', 'miscTotal', true, 'desc', 'right'),
  // new TableColumn('Total Not Invoiced', 'totalNotInvoiced', true, 'desc', 'right'),
  // new TableColumn('Debtor Invoice', 'debtorInvoice', true, 'desc', 'right'),
  new TableColumn('Total', 'totalExGST', true, 'desc', 'right'),
  new TableColumn('Diff', 'delta', false, 'desc', 'right'),
  new TableColumn('Notes', 'Notes', false, 'asc', 'centered')
  // new TableColumn('In Scope', 'InScope', true, 'asc', 'centered')
]

export { Columns, BatchQuoteColumns, AvailableQuoteColumns, BatchingQuoteColumns  }
